<template>
  <div class="edit">
    <Form ref="paasForm" slot="form"
          :model="paasFormData"
          :rules="paasFormRules"
          :label-width="defaultLabelWidth">
      <Row>
        <FormItem label="定单号："  class="ivu-col-span-24" >
          <span>{{order.orderCode}}</span>
        </FormItem>
      </Row> 
      <Row>
        <FormItem label="选择邮寄商品："  class="ivu-col-span-24" >
          <CheckboxGroup v-model="paasFormData.productIds">
            <Checkbox :label="item.id" v-for='item in order.orderProductList' :key="item.id" >
              {{item.name}}
            </Checkbox>
        </CheckboxGroup>
        </FormItem>
      </Row> 
      {{paasFormData.productId}}

      <Row>
        <FormItem label="快递名称：" prop="expressId" class="ivu-col-span-24">
          <EntitySelect v-model="paasFormData.expressId"
                         key="express"
                        :fieldConfig="expressConfig"
                        queryUrl="/eb/express/getTableData"
                        @on-change="setExpressData">
          </EntitySelect>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="快递单号：" prop="expressCode" class="ivu-col-span-24" >
          <Input v-model="paasFormData.expressCode"></Input>
        </FormItem>
      </Row>
    </Form>
  </div>
</template>

<script>
 import metaList from "@assets/js/list/meta-list.js";
 import EntitySelect from '@components/paas/refer/entitySelect';
export default {
  name: "expressRecord",
  mixins: [ metaList ],
  props: {
    order: {
        type: Object,
        default() {
          return {}
        }
      }
    },
  components:{EntitySelect},
  data() {
    return {
      serviceUrl: "/eb/order/send",
      paasFormData: {
        id: "",
        name: "",
        expressId: "",
        expressName: "",
        expressCode: "",
        expressDetail: "",
        operateUid: "",
        operateName: "",
        completeTime: "",
        orderCode:"",
        orderId:this.order.id,
        expressCom:"",
        fkaOrderProductId:'',
        needSendProductSize:this.order.needSendProductSize,
        productIds:[],
        paasRepeatSubmitFlag: "",
      },
      expressConfig: {
        idField: "id",
        nameField: "name",
        idFieldChild: "id",
        otherField:"code,expressCom@code",
        nameFieldChild: "name",
        showName: "name",
      },
      paasFormRules: {
        expressId: {message: "物流名称必填", trigger: 'blur', required: true,},
        expressCode: {message: "物流单号必填", trigger: 'blur', required: true,},
      },
      currentIdFiledName: 'id',
      defaultLabelWidth: 120,
    }
  },
  methods:{
    setExpressData(data){
      this.paasFormData.expressId = data.id;
      this.paasFormData.expressName = data.name;
      this.paasFormData.expressCom = data.expressCom;
    }
  }

}
</script>

<style>

</style>